module.exports = __webpack_public_path__ + "static/media/tapeat.88111079.svg";